import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import CustomItemStatus from "../../../../../../common/components/custom_item_status";


type Props = {
    onActionEdit: (idChecklist: number | null, openState: boolean) => void,
    onActionDelete: (idChecklist: number | null, openState: boolean) => void,
    onActionCopia: (idChecklist: number | null, openState: boolean) => void,
    onActionItens: (idChecklist: number, openState: boolean) => void,
    onActionExportReport: (idChecklist: number) => void,
}

export const GenerateChecklistEntregaColumns = ({
    onActionEdit,
    onActionDelete,
    onActionCopia,
    onActionItens,
    onActionExportReport,

}: Props): GridColDef[] => {
    const computeStatusTitle = (status: boolean) => {
        switch (status) {
            case false:
                return "Inativo";
            case true:
                return "Ativo";
            default:
                return "?";
        }
    };

    const computeStatusColor = (status: boolean) => {
        switch (status) {
            case false:
                return "#c6c6c6";
            case true:
                return "#45b6af";
            default:
                return "#0303FF";
        }
    };

    const computeStatusDescription = (status: boolean) => {
        switch (status) {
            case false:
                return "Inativo";
            case true:
                return "Ativo";
            default:
                return "?";
        }
    };

    return [
        {
            field: "ativo",
            filterable: false,
            headerName: "Status",
            minWidth: 60,
            maxWidth: 60,
            sortable: false,
            valueGetter: (_, row) => ({
                ativo: row['ativo'] as number,
            }),
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-center items-center gap-2">
                    <CustomItemStatus
                        size="autowidth"
                        textSize="small"
                        title={computeStatusTitle(value.ativo)}
                        bgColor={computeStatusColor(value.ativo)}
                        description={computeStatusDescription(value.ativo)} />
                </div>
            )
        },
        {
            field: "codigo",
            filterable: false,
            headerName: "Código",
            align: "center",
            minWidth: 100,
            width: 120,
            sortable: false,
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-center items-center gap-2 break-normal">
                    <span>{value}</span>
                </div>
            )
        },
        {
            field: "revisao",
            filterable: false,
            headerName: "Revisão",
            minWidth: 100,
            sortable: false,
            renderCell: ({ value }) => (
                <div className="w-full h-full flex justify-center items-center gap-2 break-normal">
                    <span>{value}</span>
                </div>
            )
        },
        {
            field: "descricao",
            filterable: false,
            headerName: "Descrição",
            flex: 1,
            minWidth: 200,
            sortable: false,
            renderCell: ({ value }) => (
                <div className="w-full h-full flex items-center gap-2 break-normal">
                    <span>{value}</span>
                </div>
            )
        },
        {
            field: "ambientes",
            filterable: false,
            headerName: "Ambientes",
            minWidth: 150,
            sortable: false,
            valueGetter: (_, row) => ({
                idChecklist: row['idChecklistEntrega'] as number,
            }),
            renderCell: ({ value }) => (
                <div className="w-full h-full flex items-center gap-2 break-normal">
                    <Button
                        onMouseDown={() => onActionItens(value.idChecklist, true)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        Ambientes
                    </Button>
                </div>
            )
        },
        {
            field: "relatorios",
            filterable: false,
            headerName: "Relatório",
            minWidth: 150,
            sortable: false,
            valueGetter: (_, row) => ({
                idChecklist: row['idChecklistEntrega'] as number,
            }),
            renderCell: ({ value }) => (
                <div className="w-full h-full flex items-center gap-2 break-normal">
                    <Button
                        onClick={() => onActionExportReport(value.idChecklist)}
                        sx={{
                            fontSize: 11,
                            paddingX: '.4rem',
                            paddingY: 0,
                            background: '#e6e6e6',
                            borderLeft: '.2rem solid #45b6af',
                            borderRadius: 0,
                            color: 'black',
                            fontWeight: 'normal',
                        }}>
                        exportar
                    </Button>
                </div>
            )
        },
        {
            field: 'idChecklistEntrega',
            sortable: false,
            filterable: false,
            headerName: 'Ações',
            headerAlign: 'center',
            minWidth: 230,
            renderCell: (params) => {
                return (
                    <div className="flex items-center justify-center w-full h-full gap-2">

                        <IconButton onClick={() => onActionEdit(params.value, true)}>
                            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
                        </IconButton>

                        <IconButton onClick={() => onActionDelete(params.value, true)}>
                            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                        </IconButton>

                        <IconButton onClick={() => onActionCopia(params.value, true)}>
                            <DynamicIcon nameIcon="ContentCopyRounded" size={22} className="text-purple-500 dark:text-white" />
                        </IconButton>

                    </div>
                );
            }
        }

    ];

}